import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTxt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 1.39683V14.6032C2 15.3746 2.61561 16 3.375 16H12.625C13.3844 16 14 15.3746 14 14.6032V3.67563C14 3.30251 13.8531 2.9449 13.5919 2.68251L11.3239 0.403706C11.0665 0.145065 10.7191 0 10.357 0H3.375C2.61561 0 2 0.62538 2 1.39683ZM2.875 14.6032V1.39683C2.875 1.1163 3.09886 0.888889 3.375 0.888889H10.1875V3.93651C10.1875 4.46249 10.6072 4.88889 11.125 4.88889H13.125V14.6032C13.125 14.8837 12.9011 15.1111 12.625 15.1111H3.375C3.09886 15.1111 2.875 14.8837 2.875 14.6032ZM13.125 4V3.67563C13.125 3.53995 13.0716 3.40991 12.9766 3.3145L11.0625 1.39127V3.93651C11.0625 3.97157 11.0905 4 11.125 4H13.125Z",
			fill: "#9D9C9B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4 6.5C4 6.125 4.125 6 4.5 6H11.5C11.875 6 12 6.125 12 6.5C12 6.875 11.875 7 11.5 7H4.5C4.125 7 4 6.875 4 6.5Z",
			fill: "#C9C7C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4 8.5C4 8.125 4.125 8 4.5 8H11.5C11.875 8 12 8.125 12 8.5C12 8.875 11.875 9 11.5 9H4.5C4.125 9 4 8.875 4 8.5Z",
			fill: "#C9C7C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4 10.5C4 10.125 4.125 10 4.5 10H11.5C11.875 10 12 10.125 12 10.5C12 10.875 11.875 11 11.5 11H4.5C4.125 11 4 10.875 4 10.5Z",
			fill: "#C9C7C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4 12.5C4 12.125 4.125 12 4.5 12H11.5C11.875 12 12 12.125 12 12.5C12 12.875 11.875 13 11.5 13H4.5C4.125 13 4 12.875 4 12.5Z",
			fill: "#C9C7C5"
		})
	]
});
export default SvgTxt;
